import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NavigationToggle from '@arcgis/core/widgets/NavigationToggle';
import { connect } from 'dva';
import { MAP_MODES } from '../../../lib/constants';

function NavToggle(props) {
  const [navToggle, setNavToggle] = useState(null);
  useEffect(() => {
    const navToggleWidget = new NavigationToggle({
      view: props.view,
    });

    setNavToggle(navToggleWidget);
    if (props.mapMode === MAP_MODES.ThreeD) {
      props.view.ui.add(navToggleWidget, 'manual');
    } else if (props.mapMode === MAP_MODES.TwoD) {
      props.view.ui.remove(navToggle);
    }

    return function cleanup() {
      props.view.ui.remove(navToggle);
    };
  }, [props.mapMode]);
  return null;
}

NavToggle.propTypes = {
  mapMode: PropTypes.string,
  view: PropTypes.object
};

export default connect((model) => {
  return {
    mapMode: model.map.mapMode,
  };
})(NavToggle);
